import { vuexTypes } from '../types'
import { webshopService } from '@api/webshop.service'

const state = {
  details: []
}

const mutations = {
  UPDATE_DETAILS (state, details) {
    state.details = details
  }
}

const actions = {
  async LOAD_TICKET_DETAILS ({ commit }, filter) {
    const resp = await webshopService.getTicketDetails(filter)
    if (resp._parsedData.data) {
      commit(vuexTypes.UPDATE_DETAILS, resp._parsedData.data)
    } else {
      commit(vuexTypes.UPDATE_DETAILS, [])
    }
  }
}

const getters = {
  getWebshopDetails: state => state.details
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/webshop.module.js